var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSimpleThickDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#00a3e0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a3e0",
    className: "icon-path chevron",
    d: "M6.418 9.918L14 17.5l7.582-7.582a.777.777 0 0 1 .585-.248c.236 0 .417.08.585.248a.814.814 0 0 1 0 1.17l-8.167 8.167a.814.814 0 0 1-1.17 0l-8.167-8.167a.814.814 0 0 1 0-1.17.814.814 0 0 1 1.17 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSimpleThickDown);
export default __webpack_public_path__ + "static/media/arrow-simple-thick-down.7235272e22fc6c73e0b8e5df718568a5.svg";
export { ForwardRef as ReactComponent };